import { useQuery } from '@tanstack/react-query';
import { getCommunityDescription } from '../../../services/general';
import { COMMUNITY_DESCRIPTION } from './key';

export default function useGetCommunityDescription({ state, market, community, id }) {
  return useQuery({
    queryKey: [COMMUNITY_DESCRIPTION, id],
    queryFn: async () => {
      const params = { state, market, community, id };

      const data = await getCommunityDescription(params);

      return data;
    },
    enabled: !!id,
  });
}
